/**
 * siteMapから新たなオブジェクトを作成
 * @param {Array[String]} keys siteMapから取り出すキーを指定
 * @param {Array[String]} siteMap App.vueで定義しているサイトマップ
 */
const popObjFromSiteMap = (keys, siteMap) => {
    let r = {};
    for (let i = 0; i < keys.length; i++) {
        Object.assign(r, {[keys[i]]: siteMap[keys[i]]});
    }
    return r;
}

export default popObjFromSiteMap